import React, { useEffect, useState } from "react";
import { Divider, Row, Col, Radio, Checkbox, message } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";

const StepRegItemSummaryWidget = (props) => {
  const { itemInfo, onCheck, isLast, camperIndex, userData } = props;

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontWeight: 600 }}>
        <div style={{ marginTop: 10, marginBottom: 5 }} className="block">
          <Row align={"top"} justify="space-between" gutter={[16, 4]}>
            <Col md={13}>
              {itemInfo.desc.split("\\n").map((section, secKey) => {
                return <div key={secKey}>{section}</div>;
              })}
            </Col>
            <Col
              md={4}
              style={{ textAlign: "right", marginLeft: 25 }}
            >
              ${parseFloat(itemInfo.real_fee).toFixed(2)}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default StepRegItemSummaryWidget;
